var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCirclePlus = function SvgCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-3 -3 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.125a4.875 4.875 0 1 1 0 9.75 4.875 4.875 0 0 1 0-9.75M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12m-.562-3.937a.561.561 0 1 0 1.125 0v-1.5h1.5c.311 0 .562-.251.562-.563a.56.56 0 0 0-.562-.562h-1.5v-1.5A.56.56 0 0 0 7 4.375a.56.56 0 0 0-.562.563v1.5h-1.5A.56.56 0 0 0 4.375 7c0 .312.25.563.563.563h1.5z"
  })));
};
export default SvgCirclePlus;